import React from "react";
import PropTypes from "prop-types";
import Fade from "@mui/material/Fade";

const MFade = ({children, ...otherProps}) => (
  <Fade {...otherProps} timeout={350}>
    {children}
  </Fade>
);

MFade.propTypes = {
  children: PropTypes.node,
};

export default MFade;